var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7628 0.981871L5.8828 4.86187L2.0028 0.981871C1.91022 0.889289 1.80031 0.815849 1.67935 0.765744C1.55838 0.715639 1.42873 0.68985 1.2978 0.68985C1.16687 0.68985 1.03722 0.715639 0.916259 0.765744C0.795295 0.815849 0.685384 0.889289 0.592802 0.981871C0.50022 1.07445 0.42678 1.18436 0.376675 1.30533C0.32657 1.42629 0.300781 1.55594 0.300781 1.68687C0.300781 1.8178 0.32657 1.94745 0.376675 2.06841C0.42678 2.18938 0.50022 2.29929 0.592802 2.39187L5.1828 6.98187C5.5728 7.37187 6.2028 7.37187 6.5928 6.98187L11.1828 2.39187C11.2755 2.29936 11.3491 2.18947 11.3992 2.06849C11.4494 1.94752 11.4752 1.81784 11.4752 1.68687C11.4752 1.5559 11.4494 1.42622 11.3992 1.30525C11.3491 1.18427 11.2755 1.07438 11.1828 0.981871C10.7928 0.601871 10.1528 0.591871 9.7628 0.981871Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.31bc3f12b28c1f2a5c1f95fd3cdaedc4.svg";
export { ForwardRef as ReactComponent };